import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("💥 App Crash:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="h-screen flex flex-col items-center justify-center">
                    <h1 className="text-3xl font-bold text-red-600">
                        Something went wrong
                    </h1>
                    <button
                        onClick={() => window.location.href = "/dashboard"}
                        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
                    >
                        Go to Dashboard
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;